import React from 'react';

const NumerarioContext = React.createContext();

export default NumerarioContext;
